import { render, staticRenderFns } from "./Subjects.vue?vue&type=template&id=438b3b1b"
import script from "./Subjects.vue?vue&type=script&lang=js"
export * from "./Subjects.vue?vue&type=script&lang=js"
import style0 from "./Subjects.vue?vue&type=style&index=0&id=438b3b1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports